import { css } from '@emotion/css'
import { borderRadius, spacing, fontSize, fontFamily, fontWeight } from '../../styles'
import { shorthandHelper } from '../../styles/helpers'
import getThemeColors, { colors } from '../../themes'
import { hexToRgba } from '../../themes/helpers'

const styles = {
  container: css({
    width: 240,
    maxWidth: '100%',
  }),

  wrapper: css({
    display: 'flex',
    alignItems: 'center',
    background: colors.white,
    borderRadius: borderRadius.default,
    border: `1px solid ${colors.mystic}`,
    height: 40,
    width: '100%',
    boxSizing: 'border-box',
  }),

  wrapperError: css({
    borderColor: colors.mandy,

    '&:focus-within': {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`,
    },
  }),

  wrapperWarning: css({
    borderColor: colors.sandyBrown,

    '&:focus-within': {
      borderColor: colors.sandyBrown,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.sandyBrown, 0.25)}`,
    },
  }),

  input: css({
    color: colors.jumbo,
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    lineHeight: 1.2,
    padding: shorthandHelper([spacing.small, spacing.default]),
    appearance: 'none',
    border: 'none',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    borderRadius: borderRadius.default,

    '&::placeholder': {
      color: colors.grayChateau,
      userSelect: 'none',
    },

    '&[readonly]': {
      backgroundColor: colors.athensGray,
    },

    '&:focus': {
      outline: 'none',
    },
  }),

  currencySymbol: css({
    color: colors.geyser,
    fontSize: '24px',
    fontWeight: fontWeight.semiBold,
  }),

  warning: css({ color: colors.sandyBrown }),

  error: css({ color: colors.mandy }),

  disabled: css({ backgroundColor: colors.athensGray }),

  icon: css({
    display: 'flex',
    height: 'min-content',
    padding: shorthandHelper([0, 0, 0, spacing.default]),
    pointerEvents: 'none',
  }),
}

export default styles

export const wrapperTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    '&:focus-within': {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`,
    },
  })
}
export const iconColor = (errored, warning) => {
  if (errored) return colors.mandy
  if (warning) return colors.sandyBrown
  return colors.geyser
}
